import type { HelpFile } from '../../types/help'
import { CategoryPickerDialogTestIds } from '../../../testids/CategoryPickerDialogTestIds'

export const categoryPickerDialogHelp: HelpFile = {
  texts: {
    [CategoryPickerDialogTestIds.btnClearPickerSearch]: null,
    [CategoryPickerDialogTestIds.none]: 'Diese Option wählen, um das Kategoriefeld leer zu lassen.',
  },
}
